import {
  ChangeDetectorRef,
  Component,
  ElementRef, EventEmitter,
  OnDestroy,
  OnInit, Output,
  Renderer2,
  TemplateRef,
  ViewChild,
} from '@angular/core';

import {
  DocumentValidationState,
  IDocumentElement
} from "../../../../app-main/self.scheduling/interfaces/Iself.scheduling";
import {PopupWindowService} from "../../../services/popup.window.service";
import {SystemConfigurationValues} from "../../../configuration/services/system.configuration.manager";
import {takeUntilDestroy} from "take-until-destroy";
import {
  SelfSchedulingDataService,
  SelfSchedulingDocumentAcquisitionService
} from "../../../../app-main/self.scheduling/services";

@Component({
  selector: 'document-acquisition-body',
  templateUrl: './document.acquisition.body.component.html',
  styleUrls: ['./document.acquisition.body.component.scss']
})
export class DocumentAcquisitionBodyComponent implements OnInit, OnDestroy{

  @Output() validityChanged = new EventEmitter();
  @Output() documentsLoaded = new EventEmitter();

  acquiredDocList: IDocumentElement[] = [];
  isFormValid = false;
  maxUploadSizeReached = false;
  maxFileSizeValueLabel = "";

  constructor(private changeDetector: ChangeDetectorRef,
              public selfSchedulingDocumentAcquisitionService: SelfSchedulingDocumentAcquisitionService,
              public popupWindowService: PopupWindowService, public selfSchedulingDataService: SelfSchedulingDataService,
              public cfg: SystemConfigurationValues, private renderer:Renderer2) {
  }

  ngOnInit(): void {
    this.selfSchedulingDocumentAcquisitionService.savePreviousState();
    this.maxFileSizeValueLabel = this.getFileSizeValueLabel(this.cfg.PP_ScanDocumentMaxSizeKB);
    this.selfSchedulingDocumentAcquisitionService.documentList.subscribe(updatedList => {
      this.acquiredDocList = updatedList;
      this.maxUploadSizeReached = (updatedList && updatedList.length > 0 && updatedList
        .reduce((accumulator, current) => accumulator + current.size, 0) > this.cfg.PP_ScanDocumentMaxSizeKB);
      this.isFormValid = updatedList ? (updatedList.filter(element => element.validationState !== DocumentValidationState.ValidFile).length < 1)
        && !this.maxUploadSizeReached
        : false;
      this.documentsLoaded.emit(updatedList && updatedList.length > 0);
      this.validityChanged.emit(this.isFormValid);
      this.changeDetector.markForCheck();
    })
  }

  getFileSizeValueLabel(sizeInKb: number): string {
    return (sizeInKb / 1000) < 1 ?
      sizeInKb.toFixed(1)+"KB"
      : (sizeInKb / 1000).toFixed(1)+"MB";
  }

  ngOnDestroy(): void {

  }
}
